module.exports = __webpack_public_path__ + "img/group-red.0c28243a.svg";